export const bufferToBase64 = (buffer: any): string => {
  if (!buffer) return "";
  if (buffer.type === "Buffer") {
    try {
      const text = new TextDecoder().decode(new Uint8Array(buffer.data));
      if (text.startsWith("data:image/png;base64,")) {
        return text;
      }

      const bytes = new Uint8Array(buffer.data);
      const base64 = btoa(
        bytes.reduce((data, byte) => data + String.fromCharCode(byte), "")
      );
      return `data:image/png;base64,${base64}`;
    } catch (error) {
      console.error("Buffer conversion error:", error);
      return "";
    }
  }
  return buffer;
};
